import { Inject } from '@odinjs/odin';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ModalService, PanelAPI, RadioGroupAPI, SelectableItem } from '@philips-internal/oswald-ui-components';
import { HttpService, } from '@philips-internal/oswald-ui-core/lib/services';
import Controller, { OnBeforeSubmit, OnCancel, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController';
import { CriesPainScaleAliases, FragmentNames } from '../../../codegen';
import { Endpoint } from '../../../constants/endpoints';
import './cries-pain-scale.css';

enum painScale {
  RELAXED_NORMAL = '0',
  OFTEN_WAKES_UP = '1',
  AWAKE = '2'
}

@Controller({ fragment: FragmentNames.CRIES_PAIN_SCALE })
class CriesPainScaleController extends BaseController {

  @Inject(CriesPainScaleAliases.CRIES_REFERENCE_MODAL)
  panelLoaderModalApi!: PanelAPI;

  @Inject(CriesPainScaleAliases.CRYING_RADIO_GROUP)
  cryingRadioGroupApi!: RadioGroupAPI;

  @Inject(CriesPainScaleAliases.INCREASED_HR_AND_BP_RADIO_GROUP)
  increasedHrAndBpRadioGroupApi!: RadioGroupAPI;

  @Inject(CriesPainScaleAliases.KIND_SLEEP_LAST_HOUR_RADIO_GROUP)
  kindSleepLastHourRadioGroupApi!: RadioGroupAPI;

  @Inject(CriesPainScaleAliases.OXYGEN_DEMAND_RADIO_GROUP)
  oxygenDemandRadioGroupApi!: RadioGroupAPI;

  @Inject(CriesPainScaleAliases.CRIES_FACIAL_EXPRESSION_RADIO_GROUP)
  criesFacialExpressionRadioGroupApi!: RadioGroupAPI;

  @OnMount({ target: CriesPainScaleAliases.CRYING_RADIO_GROUP})
  onMountCriesField(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.criesPainRadioGroup(685132, radioGroup);
  }

  @OnMount({ target: CriesPainScaleAliases.INCREASED_HR_AND_BP_RADIO_GROUP })
  onMountIncreaseHrAndBpField(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.criesPainRadioGroup(922937, radioGroup);
  }

  @OnMount({ target: CriesPainScaleAliases.KIND_SLEEP_LAST_HOUR_RADIO_GROUP })
  onMountKindSleepLastHour(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.criesPainRadioGroup(336098, radioGroup);
  }

  @OnMount({ target: CriesPainScaleAliases.OXYGEN_DEMAND_RADIO_GROUP })
  onMountOxygenDemand(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.criesPainRadioGroup(336095, radioGroup);
  }

  @OnMount({ target: CriesPainScaleAliases.CRIES_FACIAL_EXPRESSION_RADIO_GROUP })
  onMountCriesFacilExpression(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.criesPainRadioGroup(336097, radioGroup);
  }

  @OnClose({ target: CriesPainScaleAliases.MODAL_PAIN_SCALE_REFERENCE })
  onCloseModal(): void {
    this.panelLoaderModalApi.setVisible(false);
  }

  @OnClick({ target: CriesPainScaleAliases.REFERENCE_LINK})
  onClickReference(): void {
    this.panelLoaderModalApi.setVisible(true);
  }

  @OnCancel({ target: CriesPainScaleAliases.CRYING_FORM })
  onClickCancel(): void {
    ModalService.close('cries-pain-scale');
  }

  @OnBeforeSubmit({ target: CriesPainScaleAliases.CRYING_FORM })
  onBeforeSubmitForm(): void {
    const setPainScaleValue = this.context.get('setPainScaleValue');
    setPainScaleValue(Number(this.cryingRadioGroupApi?.getValue()?.value)
                   + (Number(this.increasedHrAndBpRadioGroupApi?.getValue()?.value))
                   + (Number(this.kindSleepLastHourRadioGroupApi?.getValue()?.value))
                   + (Number(this.oxygenDemandRadioGroupApi?.getValue()?.value))
                   + (Number(this.criesFacialExpressionRadioGroupApi?.getValue()?.value)));
    ModalService.close('cries-pain-scale');
  }

  criesPainRadioGroup(expressionId:number, radioGroup:RadioGroupAPI) :void{
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();

    HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, {encounterId, expressionId, patientId})
      .then(response => {
        if(response) {
          const responseBody = response.body as SelectableItem[];
          const items = responseBody.map(item => ({
            ...item,
            value: String(Object.values(painScale)[Number(item.key)]),
          }))
          radioGroup.setData(items);
          radioGroup.setValue(items[0]);
        }
      });
  }
}
export default CriesPainScaleController;
